import { ParentGridServices, TitleContainer } from "./styles";
import { Bonds as BondsBox } from "../CurrenciesBonds/components";
import { parseDataBonds } from "helpers";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const Bonds = () => {

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  const { data } = rest?.properties?.service;

  const { bonds, bond } = data;
  
  const getNegative = (value) => {
    if (value.indexOf("-") > -1) {
      return <p className="value variation-negative dotted-border">{value}</p>;
    }
    {
      return <p className="value variation-positive dotted-border">{value}</p>;
    }
  };

  return (
    <ParentGridServices>
      <TitleContainer>
        <h1 className="title">{bond.papel}</h1>
      </TitleContainer>
    <div className="bond-container">
      <div className="bond-body">
        <div className="bond-content first ">
          <p>Bono</p>
          <p className="value bond-name">{bond.papel}</p>
        </div>
        <div className="bond-content dotted-border second">
          <p className="">Ultimo Valor</p>
          <p className="value last-value dotted-border">{bond.ultimo}</p>
        </div>
        <div className="bond-content dotted-border">
          <p className="">Valor Anterior</p>
          <p className="value previous-value dotted-border">{bond.cierreante}</p>
        </div>
        <div className="bond-content dotted-border variation">
          <p className="">Variación</p>
          {getNegative(bond.variacao)}
        </div>
      </div>
      </div>

      <BondsBox data={parseDataBonds(bonds)} title="Otros bonos" className="detail" />
    </ParentGridServices>
  );
};
export default Bonds;
